import styled from 'styled-components';
import { AvatarStyle } from '../avatar/styles';

export const Line = styled.div(({ theme }) => {
  return `
    position: relative;
    width: 34px;
    flex-shrink: 0;
    
    &::before {
      content: '';
      display: block;
      width: 2px;
      height: 100%;
      background: ${theme.colors.commentsLine};
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    ${theme.mediaQueries.desktop} {
      width: 58px;

      &::before {
      }
    }

  `;
});

export const Square = styled.div(({ theme }) => {
  return `
    width: 16px;
    height: 16px;
    background: ${theme.colors.primary_400};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  `;
});

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;

  &:last-child {
    ${Line} {
      &.first::before {
        display: none;
      }
    }
  }

  ${(props: any) => {
    if (props['data-level'] !== 0) {
      return `
          ${Line} {
            width: 44px;

            &::before {
              display: none;
            }
          }

          ${AvatarStyle} {
            width: 44px;
            height: 44px;
            outline: none;
          }
      `;
    }
  }}
`;
